export function useShortsSrp() {
	const route = useRoute();

	// Shorts is the SRP default; shared listings keep their own behavior.
	const isShortsSrpEnabled = computed(() => route.name === 'PropertiesListing');

	return { isShortsSrpEnabled };
}
